/**
 * Teams Service - API-Client fuer das Teams-as-Modules Konzept
 */

import api from './api';

const teamsService = {
  /** Team-Katalog laden (alle verfuegbaren Team-Typen) */
  async getCatalog() {
    const response = await api.get('/teams/catalog');
    return response.data;
  },

  /** Alle aktiven Teams des Mandanten laden */
  async getTeams() {
    const response = await api.get('/teams');
    return response.data;
  },

  /** Team aktivieren (anstellen) */
  async activateTeam(teamType, name = null, config = null) {
    const response = await api.post('/teams', {
      team_type: teamType,
      name,
      config
    });
    return response.data;
  },

  /** Team-Details abrufen */
  async getTeam(teamId) {
    const response = await api.get(`/teams/${teamId}`);
    return response.data;
  },

  /** Team-Konfiguration aendern */
  async updateTeam(teamId, data) {
    const response = await api.patch(`/teams/${teamId}`, data);
    return response.data;
  },

  /** Team pausieren */
  async pauseTeam(teamId) {
    const response = await api.post(`/teams/${teamId}/pause`);
    return response.data;
  },

  /** Team archivieren (entlassen) */
  async archiveTeam(teamId) {
    const response = await api.post(`/teams/${teamId}/archive`);
    return response.data;
  },

  /** Archiviertes Team wiederherstellen */
  async restoreTeam(teamId) {
    const response = await api.post(`/teams/${teamId}/restore`);
    return response.data;
  },

  /** Basis-Teams initialisieren */
  async initializeBaseTeams() {
    const response = await api.post('/teams/initialize-base-teams');
    return response.data;
  },

  /** Sidebar-Struktur (Teams mit Projekten) */
  async getSidebarStructure() {
    const response = await api.get('/teams/sidebar/structure');
    return response.data;
  },

  /** Projekttypen fuer ein Team */
  async getProjectTypesForTeam(teamType) {
    const response = await api.get(`/teams/project-types/${teamType}`);
    return response.data;
  },

  /** KPIs fuer ein Team laden */
  async getTeamKpis(teamId) {
    const response = await api.get(`/teams/${teamId}/kpis`);
    return response.data;
  },

  /** KPI-Uebersicht fuer alle aktiven Teams */
  async getTeamsKpis() {
    const response = await api.get('/teams/all/kpis-overview');
    return response.data;
  },

  /** Module-Settings zu Teams migrieren */
  async migrateFromModules() {
    const response = await api.post('/teams/migrate-from-modules');
    return response.data;
  }
};

export default teamsService;
